import { DSTooltip } from '@repo/design-system/index'
import { QIcon_caf_pin_active, QIcon_caf_pin_inactive } from '@repo/icons/index'
import { useQueryClient } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { toast } from 'react-toastify'
import Cookies from 'universal-cookie'
import { webview_apis } from '../../../../modules/apis'
import { useCafEditTooltipV4, useCafPinned, useCafShowTooltipV4 } from '../../../../modules/apis/webview/caf'
import { s_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../modules/vars'

const PinIcon = ({ tag, isActive, tooltipDisabled = false, ...iconProps }) => {
  const cookies = new Cookies()
  const [isPinnned, setIsPinned] = useState(isActive)
  const { t } = useTranslation()
  const { mutate } = useCafPinned()
  const queryClient = useQueryClient()
  const router = useRouter()
  const lessonId = router.query?.lessonId
  const { data } = useCafShowTooltipV4('show_tooltip')
  const [isOpen, setIsOpen] = useState(data?.value === null ? true : false)
  const { mutate: editTooltip } = useCafEditTooltipV4()

  const handleClose = () => {
    // tooltip close query
    editTooltip(
      { key: 'show_tooltip', value: !isOpen },
      {
        onSuccess: () => {
          setIsOpen(false)
        },
      }
    )
  }

  const togglePin = () => {
    console.log('isOpen 값: ', isOpen)

    mutate(
      { tag, active: !isPinnned },
      {
        onSuccess: () => {
          const isStatistic = !router.asPath.includes('/lessons/review') // !개별
          if (isStatistic) {
            queryClient.invalidateQueries([webview_apis.caf.summary.highlights.list()])
          } else {
            queryClient.invalidateQueries([webview_apis.caf.highlight.list(lessonId)])
          }

          if (!isPinnned) {
            toast(t(s_caf.highlight_list_edit.toast1))
          } else {
            toast(t(s_caf.highlight_list_edit.toast2))
          }
          // 핀 설정 후
          setIsPinned(!isPinnned)
          if (isOpen) {
            // tooltip 이 열려있는 경우에만 close query 를 실행
            handleClose()
          }
        },
      }
    )
  }

  return (
    <div className="cursor-pointer">
      {!isOpen ? (
        isPinnned ? (
          <QIcon_caf_pin_active {...iconProps} fill={COLORS.PURPLE500} onClick={togglePin} />
        ) : (
          <QIcon_caf_pin_inactive {...iconProps} fill={COLORS.WHITE} onClick={togglePin} />
        )
      ) : (
        <DSTooltip
          hasCloseButton
          place="bottom"
          isMultiline={false}
          triggerComponent={
            isPinnned ? (
              <QIcon_caf_pin_active {...iconProps} fill={COLORS.PURPLE500} onClick={togglePin} />
            ) : (
              <QIcon_caf_pin_inactive {...iconProps} fill={COLORS.WHITE} onClick={togglePin} />
            )
          }
          contentComponent={t(s_caf.overview.tophighlights_info)}
          onClose={handleClose}
        />
      )}
    </div>
  )
}
export default PinIcon
